import {useId,View,DrawerNavigator} from "vritra";
import css from "./Preview.module.css";


export default function Preview(props){
    const {parent,id=useId("preview")}=props;
    const preview=DrawerNavigator({
        parent,id,
        className:css.preview,
        headerClassName:css.header,
        containerClassName:css.container,
        tintColor:mainColor,
        routes:new Array(3).fill().map((_,i)=>({
            id:"route"+(i+1),
            title:`route ${i+1}`,
            component:({parent})=>{
                const view=View({parent,className:css.routeview});
                view.innateHTML=`
                    <p>content of route N°${i+1}</p>
                `;
                return view;
            },
        })),
    });

    preview.beforeEndHTML=`
    `;


    return preview;
}
